import { CiSaveDown2 } from "react-icons/ci";
import { isEmpty, isNaN } from "lodash";
import { useEffect, useState } from "react";
import useLoading from "../../hooks/useLoading";
import useToast from "../../hooks/useToast";
import { fetchEnvVariables, updateEvnVariables } from "../../services/ api_services";
import { ToastTypes } from "../../context/ToastProvider";
import useAuth from "../../hooks/useAuth";
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
import { FaServer } from "react-icons/fa6";
import { isEqual } from "lodash";
import { axiosInstance, setBaseURL } from "../../services/axiosConfig";
import { useSystemEnv } from "./SystemEnvContext";

const listVariables = [
    { id: "maxG", name: "최대 G값" },
    { id: "normalG", name: "정상 G값" },
    { id: "warningG", name: "주의 G값" },
    { id: "highG", name: "높음 G값" },
    { id: "veryHighG", name: "매우높음 G값" },
];

const listPercents = [
    { id: "mobileBalancedRGBPercent", name: "모바일 Balance RGB (%)" },
    { id: "simulationBalancedRGBPercent", name: "시뮬레이션 Balance RGB (%)" },
    { id: "iphoneBalanceGVal", name: "아이폰 보정 G값" },
    { id: "updtDt", name: "업데이트된 날짜" },
    { id: "2", name: "" },
];

const servers = [
    { name: "로컬", id: "local", ip: process.env.REACT_APP_LOCAL_API_URL },
    { name: "개발", id: "dev", ip: process.env.REACT_APP_DEV_API_URL },
    { name: "운영", id: "prod", ip: process.env.REACT_APP_PROD_API_URL },
];

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function SystemEnvVariables() {
    const initialVariables = {
        id: 0,
        maxG: 0,
        normalG: 0,
        warningG: 0,
        highG: 0,
        veryHighG: 0,
        mobileBalancedRGBPercent: 0,
        simulationBalancedRGBPercent: 0,
        iphoneBalanceGVal: 0,
        updtDt: "",
    };

    const { setLoading } = useLoading();
    const { showToast } = useToast();
    const { auth } = useAuth();

    const [variables, setVariables] = useState(initialVariables);
    const [selectedServer, setServer] = useState(servers[0]);
    const [availableServer, setAvailableServer] = useState(servers);
    const dbConfig = localStorage.getItem("X-DB-KEY");
    const {env, setEnv} = useSystemEnv();

    const isUrinalysis = () => dbConfig && !isEmpty(dbConfig) && dbConfig === "urinalysis";
    useEffect(() => {
        if (isUrinalysis()) {
            getVariables();
        }
        console.log("SELECT ENV ===> ", env);
        // 로컬 서버는 개발용이라 운영 빌드에서는 선택지에서 뺀다.
        // (예전엔 `env === "prod"`로 비교했는데 env 는 {key:"prod"} 객체라 항상 false 였다.
        //  게다가 env 는 "현재 접속 중인 서버"라 빌드 환경 판별에는 맞지 않는다.)
        if (process.env.REACT_APP_ENV === "prod") {
            setAvailableServer(servers.filter((item) => item.id !== "local"));
        }
        configSelectedServer();
    }, []);

    const configSelectedServer = () => {
        let baseURL = "";

        const savedBaseURL = localStorage.getItem("baseURL");

        console.log("🚀 ~ configSelectedServer ~ savedServerId:", savedBaseURL);

        if (savedBaseURL && !isEmpty(savedBaseURL)) {
            baseURL = savedBaseURL;
        } else {
            baseURL = axiosInstance.defaults.baseURL;
        }

        console.log("🚀 ~ configSelectedServer ~ baseURL:", baseURL);

        const configuredServer = servers.find((item) => item.ip === baseURL);

        console.log("🚀 ~ configSelectedServer ~ configuredServer:", configuredServer);

        if (configuredServer && !isEmpty(configuredServer)) {
            setServer(configuredServer);
        }
    };

    const handleOnChangeInput = (id, value) => {
        console.log("🚀 ~ handleOnChangeInput ~ id:", id);
        console.log("🚀 ~ handleOnChangeInput ~ value:", value);
        const parsedValue = parseFloat(value);
        console.log("🚀 ~ handleOnChangeInput ~ parsedValue:", parsedValue);
        if (!isNaN(parsedValue) && parsedValue >= 0) {
            setVariables((preVal) => {
                return {
                    ...preVal,
                    [id]: parsedValue,
                };
            });
        } else {
            setVariables((preVal) => {
                return {
                    ...preVal,
                    [id]: "",
                };
            });
        }
    };

    const handleOnClickSave = async () => {
        try {
            setLoading(true);
            console.log("SAVE DATA ==> ");
            console.log("VARIABLES ==> ", variables);
            const params = {
                id: variables.id,
                max_g_val: variables.maxG,
                normal_g_val: variables.normalG,
                warning_g_val: variables.warningG,
                high_g_val: variables.highG,
                very_high_g_val: variables.veryHighG,
                mobile_balance_rgb_percent: variables.mobileBalancedRGBPercent,
                simulation_balance_rgb_percent: variables.simulationBalancedRGBPercent,
                iphone_balance_g_val: variables.iphoneBalanceGVal,
                updt_id: auth.admin_seq,
            };
            const saveResponse = await updateEvnVariables(params);
            console.log("🚀 ~ handleOnClickSave ~ saveResponse:", saveResponse);
            setLoading(false);
            if (saveResponse.status === 200 && saveResponse.data && !isEmpty(saveResponse.data)) {
                showToast(ToastTypes.SUCCESS, "성공", "환경 설정을 완료했습니다.");
                const updatedData = saveResponse.data;
                console.log("🚀 ~ handleOnClickSave ~ updatedData:", updatedData);
                setVariables((preVal) => {
                    return {
                        ...preVal,
                        id: updatedData.id,
                        maxG: updatedData.max_g_val,
                        normalG: updatedData.normal_g_val,
                        warningG: updatedData.warning_g_val,
                        highG: updatedData.high_g_val,
                        veryHighG: updatedData.very_high_g_val,
                        mobileBalancedRGBPercent: updatedData.mobile_balance_rgb_percent,
                        simulationBalancedRGBPercent: updatedData.simulation_balance_rgb_percent,
                        iphoneBalanceGVal: updatedData.iphone_balance_g_val,
                    };
                });
            } else {
                showToast(ToastTypes.ERROR, "실패", "환경 설정할 때 오류 났습니다.");
            }
        } catch (e) {
            setLoading(false);
            console.error("Error fetching data: ", e);
        }
    };

    const handleOnClickSaverServer = () => {
        console.log("Selected server ==> ", selectedServer);
        let baseURL = "";
        switch (selectedServer.id) {
            case "dev":
                baseURL = process.env.REACT_APP_DEV_API_URL;
                break;
            case "prod":
                baseURL = process.env.REACT_APP_PROD_API_URL;
                break;
            case "local":
                baseURL = process.env.REACT_APP_LOCAL_API_URL;
                break;
            default:
                break;
        }

        console.log("🚀 ~ handleOnChangeServer ~ baseURL:", baseURL);
        setBaseURL(baseURL);
        localStorage.setItem("baseURL", selectedServer.ip);
        localStorage.setItem("curServer", selectedServer.id)
        showToast(ToastTypes.SUCCESS, "서버", "접속 서버 설정을 완료했습니다.");
        setEnv(prev => ({
            ...prev,
            key: selectedServer.id,
        }));

        // console.log("Configured server : ", process.env.REACT_APP_DEV_API_URL);
        // console.log("API URL : ", process.env.REACT_APP_API_URL);
        // console.log("SELECTED SERVER ID ", id);
        // if (id && !isEmpty(id)) {
        //     let baseURL = "";
        //     const serverName = servers.find((i) => i.id === id).name;
        //     switch (id) {
        //         case "dev":
        //             baseURL = process.env.REACT_APP_DEV_API_URL;
        //             break;
        //         case "prod":
        //             baseURL = process.env.REACT_APP_PROD_API_URL;
        //             break;
        //         case "local":
        //             baseURL = process.env.REACT_APP_LOCAL_API_URL;
        //             break;
        //     }
        //     console.log("🚀 ~ handleOnChangeServer ~ serverName:", serverName);
        //     console.log("🚀 ~ handleOnChangeServer ~ baseURL:", baseURL);
        //     setServer(serverName);
        //     setBaseURL(baseURL);
        //     Cookies.set("serverId", id, { secure: true, sameSite: "strict" });
        // } else {
        //     console.log("🚀 ~ handleOnChangeServer ~ selectedServer:", selectedServer);
        //     if (isEmpty(selectedServer)) {
        //         const savedServerId = Cookies.get("serverId");
        //         console.log("🚀 ~ handleOnChangeServer ~ savedServerId:", savedServerId);
        //         let serverId = "";
        //         if (savedServerId && !isEmpty(savedServerId)) {
        //             const foundServer = servers.find((i) => i.id === savedServerId);
        //             if (foundServer) {
        //                 setServer(foundServer.name);
        //             }
        //         } else {
        //             switch (process.env.REACT_APP_API_URL) {
        //                 case process.env.REACT_APP_DEV_API_URL:
        //                     serverId = "dev";
        //                     break;
        //                 case process.env.REACT_APP_PROD_API_URL:
        //                     serverId = "prod";
        //                     break;
        //                 case process.env.REACT_APP_LOCAL_API_URL:
        //                     serverId = "local";
        //                     break;
        //             }
        //             Cookies.set("serverId", serverId, { secure: true, sameSite: "strict" });
        //             const foundServer = servers.find((i) => i.id === serverId);
        //             if (foundServer) {
        //                 setServer(foundServer.name);
        //             }
        //         }
        //     }
        // }
    };

    const handleOnClickSearch = async () => {
        await getVariables();
    };

    async function getVariables() {
        setLoading(true);
        try {
            const response = await fetchEnvVariables();
            console.log("🚀 ~ getVariables ~ response:", response);
            if (response.status === 200) {
                console.log("response.data: ", response.data);
                if (response.data && !isEmpty(response.data)) {
                    showToast(ToastTypes.SUCCESS, "성공", "조회를 완료했습니다.");
                    const envVariables = response.data[0];
                    console.log("🚀 ~ getVariables ~ envVariables:", envVariables);
                    setVariables((preVal) => {
                        return {
                            ...preVal,
                            id: envVariables.id,
                            maxG: envVariables.max_g_val,
                            normalG: envVariables.normal_g_val,
                            warningG: envVariables.warning_g_val,
                            highG: envVariables.high_g_val,
                            veryHighG: envVariables.very_high_g_val,
                            simulationBalancedRGBPercent: envVariables.simulation_balance_rgb_percent,
                            mobileBalancedRGBPercent: envVariables.mobile_balance_rgb_percent,
                            iphoneBalanceGVal: envVariables.iphone_balance_g_val,
                            updtDt: formatDate(envVariables.updt_dt),
                        };
                    });
                }
            }
            setLoading(false);
        } catch (e) {
            setLoading(false);
            console.error("Error fetching data: ", e);
        }
    }

    function formatDate(dateString) {
        const options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        };
        const date = new Date(dateString);
        return new Intl.DateTimeFormat("en-US", options).format(date).replace(/(\d{2})\/(\d{2})\/(\d{4}),/, "$3-$1-$2");
    }

    return (
        <div className="mx-auto max-w-full">
            <div className="inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8 px-6 bg-white shadow rounded">
                <span className="flex text-center justify-start align-middle text-nowrap text-gray-700 font-semibold text-xl">
                    서버 설정
                </span>
                <div className="py-2 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 min-h-24">
                    {availableServer.map((item) => (
                        <div className="sm:col-span-2 items-center justify-center">
                            <div
                                className={classNames(
                                    isEqual(selectedServer, item) ? "border-2 border-blue-600" : "",
                                    "w-full inline-flex rounded bg-gray-100  px-3 py-2 items-center justify-start focus:border-blue-500 hover:border-blue-500 hover:border hover:cursor-pointer hover:shadow-md"
                                )}
                                onClick={() => setServer(item)}
                            >
                                <FaServer className="-ml-0.5 h-5 w-5 min-w-5" aria-hidden="true" />
                                <div className="px-3 text-gray-700 overflow-hidden ">
                                    <span className="block font-bold">{item.name}</span>
                                    <span className="font-normal text-base text-gray-400 text-nowrap">{item.ip}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="py-2 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                    <div className="sm:col-span-5" />
                    <div className="sm:col-span-1 inline-flex justify-end">
                        <button
                            type="button"
                            className="min-w-32 w-32 rounded inline-flex gap-x-1 items-center justify-center bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            onClick={() => handleOnClickSaverServer()}
                        >
                            <CiSaveDown2 className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                            저장
                        </button>
                    </div>
                </div>
            </div>
            {isUrinalysis() && (
                <div className="mt-4 inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8 px-6 bg-white shadow rounded">
                    <span className="flex text-center justify-start align-middle text-nowrap text-gray-700 font-semibold text-xl">
                        환경 설정
                    </span>
                    <table className="min-w-full divide-y divide-gray-200 mt-6">
                        <thead key={"variables_header"}>
                            <tr>
                                {listVariables.map((variable) => (
                                    <th
                                        key={variable.id}
                                        scope="col"
                                        className="px-3 py-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                                    >
                                        {variable.name}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            <tr>
                                {listVariables.map((variable) => (
                                    <td key={variable.id} className="px-0 py-3 text-sm text-gray-500">
                                        <input
                                            className="border-gray-300 rounded-md"
                                            value={variables[variable.id] ?? 0}
                                            maxLength={4}
                                            type={"number"}
                                            id={variable.id}
                                            disabled={variable.id === "updtDt"}
                                            onChange={(e) => handleOnChangeInput(variable.id, e.target.value)}
                                        />
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                    </table>
                    <table className="min-w-full divide-y divide-gray-200 ">
                        <thead key={"percents_header"}>
                            <tr>
                                {listPercents.map((variable) => (
                                    <th
                                        key={variable.id}
                                        scope="col"
                                        className="px-3 py-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                                    >
                                        {variable.name}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            <tr>
                                {listPercents.map((variable) => (
                                    <td key={variable.id} className="px-0 py-3 text-sm text-gray-500">
                                        <input
                                            className="border-gray-300 rounded-md"
                                            value={variables[variable.id] ?? ""}
                                            maxLength={4}
                                            type={variable.id === "updtDt" ? "text" : "number"}
                                            id={variable.id}
                                            disabled={variable.id === "" || variable.id === "updtDt"}
                                            onChange={(e) => handleOnChangeInput(variable.id, e.target.value)}
                                        />
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                    </table>
                    <div className="flex w-full justify-end items-center align-middle mt-6">
                        <button
                            type="button"
                            className="w-32 rounded-md inline-flex gap-x-1 items-center justify-center mr-4 bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                            onClick={() => handleOnClickSearch()}
                        >
                            <MagnifyingGlassIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                            조회
                        </button>
                        <button
                            type="button"
                            className="w-32 rounded-md inline-flex gap-x-1 items-center justify-center bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            onClick={() => handleOnClickSave()}
                        >
                            <CiSaveDown2 className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                            저장
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
